import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["Icon", "ariaLabel", "onClick", "size", "variant", "loading", "wrapperStyle"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { forwardRef, useMemo } from 'react';
import { Spinner } from '../spinner';
import { jsx as _jsx } from "react/jsx-runtime";
export var IconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var Icon = props.Icon,
      ariaLabel = props.ariaLabel,
      onClick = props.onClick,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'neutral' : _props$variant,
      loading = props.loading,
      wrapperStyle = props.wrapperStyle,
      restProps = _objectWithoutProperties(props, _excluded);

  var iconSizeClasses = useMemo(function () {
    return size === 'sm' ? '!h-5 !w-5' : '!h-6 !w-6';
  }, [size]);
  return /*#__PURE__*/_jsx(Wrapper, {
    wrapperStyle: wrapperStyle,
    size: size,
    children: /*#__PURE__*/_jsx(StyledButton, _objectSpread(_objectSpread({
      variant: variant,
      size: size,
      "aria-label": ariaLabel,
      onClick: onClick //@ts-expect-error - ref type is not properly inferred
      ,
      ref: ref,
      loading: loading
    }, restProps), {}, {
      children: loading ? /*#__PURE__*/_jsx(_StyledSpinner, {
        className: iconSizeClasses,
        color: variant
      }) : /*#__PURE__*/_jsx(Icon, {
        className: iconSizeClasses
      })
    }))
  });
});
export default IconButton;
var iconColorStyles = {
  success: {
    "--tw-text-opacity": "1",
    "color": "rgb(0 84 45 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(0 84 45 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(0 84 45 / 0.2)"
    }
  },
  warning: {
    "--tw-text-opacity": "1",
    "color": "rgb(158 84 0 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(158 84 0 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(158 84 0 / 0.2)"
    }
  },
  error: {
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(145 0 24 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(145 0 24 / 0.2)"
    }
  },
  restworld: {
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(72 36 133 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(72 36 133 / 0.2)"
    }
  },
  reversed: {
    "backgroundColor": "rgb(255 255 255 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":active": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
    }
  },
  neutral: {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(0 0 26 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(0 0 26 / 0.2)"
    }
  }
};
var iconLoadingBgColorStyles = {
  success: {
    "backgroundColor": "rgb(0 84 45 / 0.1)",
    ":hover": {
      "backgroundColor": "rgb(0 84 45 / 0.1)"
    }
  },
  warning: {
    "backgroundColor": "rgb(158 84 0 / 0.1)",
    ":hover": {
      "backgroundColor": "rgb(158 84 0 / 0.1)"
    }
  },
  error: {
    "backgroundColor": "rgb(145 0 24 / 0.1)",
    ":hover": {
      "backgroundColor": "rgb(145 0 24 / 0.1)"
    }
  },
  restworld: {
    "backgroundColor": "rgb(72 36 133 / 0.1)",
    ":hover": {
      "backgroundColor": "rgb(72 36 133 / 0.1)"
    }
  },
  reversed: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
    }
  },
  neutral: {
    "backgroundColor": "rgb(28 28 51 / 0.1)",
    ":hover": {
      "backgroundColor": "rgb(0 0 26 / 0.1)"
    }
  }
};

var Wrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "icon-button__Wrapper",
  componentId: "sc-srgjh2-0"
})(["", " ", " ", ""], {
  "display": "grid",
  "placeItems": "center"
}, function (_ref) {
  var size = _ref.size;
  return size === 'sm' ? {
    "height": "26px",
    "width": "26px"
  } : {
    "height": "42px",
    "width": "42px"
  };
}, function (_ref2) {
  var wrapperStyle = _ref2.wrapperStyle;
  return wrapperStyle || {};
});

var StyledButton = /*#__PURE__*/_styled.button.withConfig({
  displayName: "icon-button__StyledButton",
  componentId: "sc-srgjh2-1"
})(["", " ", " ", " ", ";", " ", ""], {
  "margin": "0px",
  "display": "grid",
  "placeItems": "center",
  "borderStyle": "none",
  "padding": "0px",
  "color": "inherit",
  "outline": "2px solid transparent",
  "outlineOffset": "2px",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms",
  ":hover": {
    "cursor": "pointer"
  },
  ":focus-visible": {
    "outlineWidth": "4px",
    "outlineColor": "#e88a99"
  }
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'sm' ? {
    "height": "1.5rem !important",
    "width": "1.5rem !important",
    "borderRadius": "4px",
    ":active": {
      "height": "22px",
      "width": "22px"
    }
  } : {
    "height": "2.5rem !important",
    "width": "2.5rem !important",
    "borderRadius": "0.5rem",
    ":active": {
      "height": "38px",
      "width": "38px"
    }
  };
}, function (_ref4) {
  var _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'neutral' : _ref4$variant;
  return iconColorStyles[variant];
}, function (_ref5) {
  var disabled = _ref5.disabled,
      loading = _ref5.loading;
  return disabled || loading ? {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))",
    ":hover": {
      "cursor": "not-allowed",
      "backgroundColor": "transparent"
    }
  } : {};
}, function (_ref6) {
  var loading = _ref6.loading,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'neutral' : _ref6$variant;
  return loading && iconLoadingBgColorStyles[variant];
}, function (_ref7) {
  var twStyle = _ref7.twStyle;
  return twStyle || {};
});

var _StyledSpinner = /*#__PURE__*/_styled(Spinner).withConfig({
  displayName: "icon-button___StyledSpinner",
  componentId: "sc-srgjh2-2"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
});